export const Steps = {
  WEBSITE: 'website',
  BASIC_INFO: 'basic-info',
  PROCESS: 'process',
  SUCCESS: 'success'
}
